/**
 * Image with Text Tabs Section Component
 * A custom element that manages tabbed content with image and text sections
 */

// Constants for class names and selectors
const SELECTORS = {
  TAB_LABEL: '.js-radio-tab',
  TAB_CONTENT: '.js-image-text-tabs__tab-content'
};

const CLASSES = {
  HIDDEN: 'is-hidden'
};

/**
 * Custom element for image with text tabs section
 */
class SectionImageWithTextTabs extends HTMLElement {
  constructor() {
    super();
    
    // Initialize properties
    this.tabLabels = null;
    this.tabs = null;
    
    // Bind methods to preserve context
    this.changeTabEventHandler = this.changeTabEventHandler.bind(this);
  }

  /**
   * Lifecycle callback when element is added to the DOM
   */
  connectedCallback() {
    this.initializeElements();
    this.attachEventListeners();
  }

  /**
   * Lifecycle callback when element is removed from the DOM
   */
  disconnectedCallback() {
    this.detachEventListeners();
  }

  /**
   * Initialize DOM elements
   * @private
   */
  initializeElements() {
    this.tabLabels = this.querySelectorAll(SELECTORS.TAB_LABEL);
    this.tabs = this.querySelectorAll(SELECTORS.TAB_CONTENT);
  }

  /**
   * Attach event listeners to tab labels
   * @private
   */
  attachEventListeners() {
    this.tabLabels.forEach(tab => {
      tab.addEventListener('change', this.changeTabEventHandler);
    });
  }

  /**
   * Detach event listeners from tab labels
   * @private
   */
  detachEventListeners() {
    this.tabLabels.forEach(tab => {
      tab.removeEventListener('change', this.changeTabEventHandler);
    });
  }

  /**
   * Handle tab change event
   * @param {Event} event - The change event
   * @private
   */
  changeTabEventHandler(event) {
    const tab = event.target.closest(SELECTORS.TAB_LABEL);
    if (!tab) return;

    const tabValue = tab.value;
    this.changeTab(tabValue);
  }

  /**
   * Change the active tab
   * @param {string} currentTab - The value of the tab to activate
   * @private
   */
  changeTab(currentTab) {
    this.tabs.forEach(tab => {
      const tabHandle = tab.dataset.tab;
      const isActive = currentTab === tabHandle;
      
      tab.classList.toggle(CLASSES.HIDDEN, !isActive);
    });
  }
}

// Register the custom element if it hasn't been registered yet
if (!customElements.get('s-image-text-tabs')) {
  customElements.define('s-image-text-tabs', SectionImageWithTextTabs);
}